import { VerificationType } from "@obg/ngx.common";

import { CustomerVerificationKeys } from "./customer-verification.model";

export const CUSTOMER_VERIFICATION_KEYS: Record<string, CustomerVerificationKeys> = {
	[VerificationType.created]: {
		titleKey: "customer-verification.account-created",
		listItemKey: "customer-verification.deposit",
		buttonKey: "customer-verification.deposit",
	},
	[VerificationType.verified]: {
		titleKey: "customer-verification.account-verified",
		listItemKey: "customer-verification.select-bonus-and-deposit",
		buttonKey: "customer-verification.button-login",
	},
	[VerificationType.withRewards]: {
		titleKey: "customer-verification.account-created",
		listItemKey: "customer-verification.select-bonus-and-deposit",
		buttonKey: "customer-verification.button-select-bonus",
	},
};

export const enum CustomerVerificationEvent {
	WelcomeMessageOpen = "WelcomeMessageOpen",
	WelcomeMessageClick = "WelcomeMessageClick",
}

export const enum CustomerVerificationClickedItem {
	WelcomeBonus = "WelcomeBonus",
	Login = "Login",
	Deposit = "Deposit",
	EnterSite = "EnterSite",
}
